import { DEVELOPMENT_AUTH0_CLIENT_ID } from "@thalamos/haven-common";

/**
 * All environment configuration is read here, so the rest of the app need not
 * touch `import.meta.env` — except a condition that must settle an `import()`
 * at build time, which has to be read beside it.
 *
 * Every value has a local default because `.env*` is gitignored repo-wide, so
 * no example file can be committed for a new developer to copy. The defaults
 * point at the local dev stack; override them with a local `.env` (see README).
 */
export type HavenConfig = {
  backendUrl: string;
  environment: string;
  version: string;
  auth0: {
    domain: string;
    clientId: string;
  };
  datadog: {
    applicationId: string;
    clientToken: string;
    disableTracing: boolean;
  };
  googlePlaces: {
    apiKey: string;
  };
};

export const config: HavenConfig = {
  backendUrl:
    import.meta.env.VITE_BACKEND_URL ||
    "http://haven-api.local.thalamosapp.co.uk:8081",
  environment: import.meta.env.VITE_ENVIRONMENT || "local",
  version: import.meta.env.VITE_CODE_VERSION || "unknown",
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN || "thalamos-dev.uk.auth0.com",
    // Defaulted only for the dev server: `import.meta.env.DEV` is false in any
    // build, where an unset value stays empty. The id is the shared constant
    // rather than a literal because the server defaults to the same one, and it
    // has to be the same one — see its docblock for what a mismatch does.
    clientId:
      import.meta.env.VITE_AUTH0_CLIENT_ID ||
      (import.meta.env.DEV ? DEVELOPMENT_AUTH0_CLIENT_ID : ""),
  },
  datadog: {
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID || "",
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN || "",
    // RUM is off unless an application id and token are supplied, so a local
    // run never ships session data to Datadog by accident.
    disableTracing:
      import.meta.env.VITE_DATADOG_DISABLE_TRACING === "true" ||
      !import.meta.env.VITE_DATADOG_APPLICATION_ID ||
      !import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  },
  googlePlaces: {
    // Empty turns address search off.
    apiKey: import.meta.env.VITE_GOOGLE_PLACES_API_KEY || "",
  },
};
